import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-12">
          常见问答
        </h2>
        <div className="flex flex-col gap-8">
          {faqData.map((faq) => (
            <div key={faq.id}>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-3">
                {faq.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {faq.answer}
              </p>
              <div className="mt-6 border-b border-background-200"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}